import React from "react";
import Navbar from "../Components/Navbar";
import '../Styles/Contact.scss';
import {Helmet} from "react-helmet";
import Footer from "../Components/Footer.js";

function Contact() {
      const [shown, setShown] = React.useState(false)


   return (
      <div>
      <Helmet>
            <title>Contact Us - Camp Connect</title>
         </Helmet>
      <div className="ContactOuterContainer">
         <Navbar/>

         <div className="ContactInnerContainer">

            <div className="ContactTitleOuterContainer">
               <div className="ContactTitleInnerContainer">
                  <div className="ContactTitleText1">
                     <>Contact Us</>
                  </div>
               </div>
            </div>


            <div className="ContactBoxesOuterContainer">

            <div className="ContactPhoneBox">
               <div className="ContactPhoneBoxInnerContainer">
                     <div className="ContactPhoneBoxTitleText">
                        <>Phone</>
                     </div>

                     <div className="ContactPhoneBoxBodyText">
                        <>
                           (850)-478-8496
                        </>
                     </div>

                     <div className="ContactPhoneBoxButton">
                        <>
                           Hours: M-F<br></br>
                           8:00 AM - 4:30 PM
                        </>
                     </div>
               </div>
            </div>

            <div className="vl"></div>


            <div className="ContactAddressBox">
               <div className="ContactAddressBoxInnerContainer">
                     <div className="ContactAddressBoxTitleText">
                        <>Address</>
                     </div>

                     <div className="ContactAddressBoxBodyText">
                        <>
                           250 Brent Lane,<br></br>
                           Pensacola, FL 32503 
                        </>
                     </div>

                     <div className="ContactAddressBoxButton">
                        <div className="ContactAddressBoxButtonSignUp">

                        {shown ?<iframe id="frame" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3438.6394591277763!2d-87.23501958458034!3d30.474648605075462!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8890bf92dfae0c05%3A0x3b8938693e35d55b!2sPensacola%20Christian%20College!5e0!3m2!1sen!2sus!4v1680551029504!5m2!1sen!2sus" title="Camp Connect Location"></iframe>: null}
                        <button onClick={() => setShown(!shown)}>Maps</button>
                        </div>
                     </div>
               </div>
            </div>

            <div className="vl"></div>


            <div className="ContactEmailBox">
               <div className="ContactEmailBoxInnerContainer">
                     <div className="ContactEmailBoxTitleText">
                        <>Email</>
                     </div>

                     <div className="ContactEmailBoxBodyText">
                        <>
                       info@pcci.edu
                        </>
                     </div>

                     <div className="ContactEmailBoxButton">
                     {/* need this div for styling */}
                     </div>
               </div>
            </div>

            </div>

         </div>
      </div>
      <Footer/>
      </div>
   )
};

export default Contact;
